import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import NavbarPC from "../../../components/navbar-pc";
import NavbarMobile from "../../../components/navbar-mobile/navbar-mobile";
import "./style.css";
import "./colors.css";
import { isWebView } from "../../../global-components/src/utils/text";
import NavbarRight from "../../../components/navbar-right/navbar-right";
import NavbarTop from "../../../components/navbar-top/navbar-top";

const Main = () => {
    const location = useLocation();
    // console.clear();
    console.log('%cDesenvolvido pelo João Enrique', 'font-size: 30px; color: red;');
    console.log(`%chttps://github.com/JoaoEnrique`, 'font-size: 20px; color: #5bb4ff;');
    console.log(`%cRead Books ${new Date().getFullYear()}`, 'font-size: 30px; color: #5bb4ff;');

    // Estados para os plugins
    const [isAccessibilityEnabled, setIsAccessibilityEnabled] = useState(!!sessionStorage.getItem("accessibilityPlugin"));
    const [isPoundsEnabled, setIsPoundsEnabled] = useState(!!sessionStorage.getItem("poundsPlugin"));

    useEffect(() => {
        // Função para monitorar mudanças no sessionStorage
        const handleStorageChange = () => {
            setIsAccessibilityEnabled(!!sessionStorage.getItem("accessibilityPlugin"));
            setIsPoundsEnabled(!!sessionStorage.getItem("poundsPlugin"));
        };

        // Adiciona evento de escuta para mudanças no sessionStorage
        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);

    useEffect(() => {
        if (!isWebView()) {
          document.body.classList.add("not-webview");
        }
      }, []);
    
    return (
        <div>
            {location.pathname != "/" && (
                <div className="none-pc">
                <NavbarTop />
            </div>
            )}
            <NavbarRight />
           
            

            {/* Conteúdo das Páginas Filhas */}
            <main>
                <Outlet />

                {/* Carrega o plugin de acessibilidade apenas se ativado */}
                {isAccessibilityEnabled && (
                    <script async src="https://cdn.userway.org/widget.js" data-account="KZUGb7OX4z"></script>
                )}
            </main>
        </div>
    );
};

export default Main;
